(function() {
'use strict';

function createTab(init) {

	const tab = this;
	const attachmentTab = AppTabs.getTab('attachment');
	var vmSampleLogin = null,
		sampleLoginTab = null,
		vmProjectName = null,
		projectNameTab = null;
	init.setDataTableArgs( {

		tableId: 		'#data-table-samples',

		readTableName: 	'tblSamples',
		editTableName: 	'tblSamples',
		primaryKey: 	'SampleID',

		hasColumnFilters: 	false,
		canSearch: 			false,
		canSort:			false,
		paging:             false,
		pagelength:         -1,

		actionData:			'datatable_get_samples',

		fields: [
			{
				label:      'Sample Number',
				columnName: 'SampleNumber',
				type:       'sample-link',
		 	},
			{
				label:      'Sample Description',
				columnName: 'SampleDescription',
				type:       'sample-link',
			},
			{
				label:      'Sample From Date',
				columnName: 'SampleFromDate',
				type:       'date',
		 	},
			{
				label:      'Sample To Date',
				columnName: 'SampleToDate',
				type:       'date',
		 	},
			{
				label:      'Preservation',
				columnName: 'Preservation',
			},
			{
				label:      'Preserved By',
				columnName: 'PreservedBy',
			},
			{
				label:      'Collection Method',
				columnName: 'CollectionMethod',
			},
		],

		// Adds additional data fields to ajax requests when drawing the table
		ajaxDataCallback : function( data, settings ) {
			data.JobID = tab.controller.JobID || -1;
			return data;
		},

	} );

    init.setController( new TabControllerVue({
        el: '#v-project',
        store, // vuex store
		lockUpdates: true,
        methods: {
			clearProjectData: function() {
				this.reset();
				tab.autofocus();
				return true;
			},
			resetData: function() {
				this.JobID          = null;
				this.AddressID      = null;
				this.ClientID       = null;
				this.ClientLoginComment = null;
				this.ClientAddresses = [];
				this.DefaultContact = null;
				this.DeliveryMode   = [];
				this.FieldTech      = null;
				this.JobDescription = null;
				this.JobNumber      = null;
				this.JobPO          = null;
				this.JobStatusID    = 1;
				this.LabComment     = null;
				this.LoginDate      = null;
				this.ProjectID      = null;
				this.ReportComment  = null;
				this.ReportMethod   = null;
				this.SampledBy      = null;
				this.SampleCount    = 0;
				this.Shelves        = null; // Format mismatch...
				this.DateReported   = null;

				// Not tied in!!
				this.cocLetter = null;
				this.reported = null;

				this.client = null;
				this.jobStatus = store.state.jobStatusOptions.find( x => x.id == 1 ) || null;
				this.clientData = {
					Projects: [],
				};

				this.projectProject = null;

				this.projectGoBetween = null;

				this.attachments =  [];
				this.attachmentDir = '';
			},
			onReset: function() {
				tab.clearTable();
			},
			onOpenTab() {
				if ( this.JobID == null )
					this.LoginDate = getLocalISODate(); // Get today's ISO 8601 date for <input type="date">
			},
			// Create a new project
			newProjectData: function() {
				this.JobNumber = null;
				this.JobID = null;
				this.updateProject({
					ClientID       : this.client ? this.client.id : null,
					DefaultContact : this.DefaultContact,
					DeliveryMode   : this.DeliveryMode,
					FieldTech      : this.FieldTech,
					JobPO          : this.JobPO,
					JobStatusID    : 1,
					LabComment     : this.LabComment,
					LoginDate      : new Date( this.LoginDate ).valueOf() // NaN (falsey) if invalid
										   ? this.LoginDate
										   : getLocalISODate(), // Get today's ISO 8601 date for <input type="date">,
					ProjectID      : this.ProjectID,
					JobDescription : this.JobDescription,
					ReportComment  : this.ReportComment,
					ReportMethod   : this.ReportMethod,
					SampledBy      : this.SampledBy,
					Shelves        : this.Shelves,
				}, true);
				tab.autofocus();
			},

			doCreateNew() { this.clearProjectData(); tab.autofocus(); },

			// Delete a project

			// Open the samples tab and set this project as the current one
			loginSample: function(){
				vmSampleLogin.loginSampleFromJobId( this.JobID, () => {
					this.SampleCount++;
					this.loadProject( this.JobNumber );
					if ( sampleLoginTab )
						sampleLoginTab.showAndAutofocus();
				} );
			},

			doLogin() { return this.loginSample(); },

			updateProject: function(data, insert = false, onSuccess = null, onError = null) {
				if ( this.getUpdateLockLevel() ) { return; }
				if ( ! insert && ! this.JobID ) { return; }
				if ( ! this.client || ! this.client.id || this.client.id <= 0 || this.client.text === null ) {
					/*return WarningModalManager.show({
						title   : "Missing client",
						message : "Please select a client before adding.",
					});*/
					return;
				}
				const _this = this;

				window.ajaxCall({
					data : {
						action: 'update_project_data',
						id: this.JobID,
						data: data,
					},
					onSuccess : function( response ) {
						if ( ! response.success || ! response.data ) {
							console.log( response.message ? response.message : response );
							return;
						}
						const data = 'projectData' in response.data ? response.data.projectData : response.data;
						if ( data && _this.JobID != data.JobID ) {
							_this.loadProjectData( data, onSuccess );
						}
					},
					onError: function() { typeof onError == 'function' && onError() },
				});
			},

			loadProjectData: function ( data, onLoaded = null ) {
				const projectData = data.projectData || data;
				if ( !projectData ) { return this.clearProjectData(); }

				this.lockUpdates( ' loadProjectData' );
				this.client         = projectData.ClientID && this.clientList && this.clientList.find( x => x.id == projectData.ClientID ) || null;
				this.jobStatus      = this.jobStatusOptions && this.jobStatusOptions.find( x => x.id == projectData.JobStatusID ) || null;
				this.ClientID       = projectData.ClientID;
				this.DefaultContact = projectData.DefaultContact;
				this.DeliveryMode   = projectData.DeliveryMode;
				this.FieldTech      = projectData.FieldTech;
				this.JobDescription = projectData.JobDescription;
				this.JobID          = projectData.JobID;
				this.JobNumber      = projectData.JobNumber;
				this.JobPO          = projectData.JobPO;
				this.JobStatusID    = projectData.JobStatusID;
				this.LabComment     = projectData.LabComment;
				this.LoginDate      = projectData.LoginDate;
				this.ProjectID      = projectData.ProjectID;
				this.ReportComment  = projectData.ReportComment;
				this.ReportMethod   = projectData.ReportMethod;
				this.SampledBy      = projectData.SampledBy;
				this.SampleCount    = projectData.SampleCount;
				this.Shelves        = projectData.Shelves;
				this.DateReported   = projectData.DateReported;
				this.attachments    = projectData.attachments || [];
				this.attachmentDir  = projectData.attachmentDir || '';
				this.projectProject = null;
				this.projectGoBetween = null;
				tab.drawTable();
				this.unlockUpdatesLater( 'loadProjectData', () => {
					tab.autofocus();
					if ( this.client ) {
						this.ajaxLoadClientData( onLoaded );
					} else {
						typeof onLoaded == 'function' && onLoaded();
					}
				} );
			},

			loadProject: function( projectNumber, onSuccess = null, onError = null ) {
				const vm = this;
				projectNumber = parseInt( projectNumber );
				if ( ! projectNumber ) {
					alert( 'Invalid Project Number' );
					return;
				}
				this.reset();
				this.lockUpdates( 'in loadProject before AJAX' );
				this.JobNumber = projectNumber;

				window.ajaxCall({
					data : {
						action: 'get_project_data',
						projectNumber: projectNumber
					},
					onSuccess : function( response ) {
						vm.loadProjectData( response.data, onSuccess );
						vm.unlockUpdates( 'loadProject onSuccess' ); // loadProjectData still has a waiting lock
					},
					onError : function( response ) {
						alert( 'Could Not Load Project Number: ' + projectNumber );
						vm.unlockUpdatesLater( 'loadProject onError', onError );
					},
				});
			},

			ajaxLoadClientData: function(onSuccess = null, onError = null) {
				if ( ! this.client ) {
					return;
				}
				const vm = this;
	            window.ajaxCall({
	                data : {
	                    action: 'get_client_data',
	                    client_id: vm.client.id
	                },
	                onSuccess : function( response ) {
						const clientData = response.data;

						vm.ClientLoginComment = clientData.ClientLoginComments;
						//get project data
						vm.clientData = clientData;
						if ( vm.ProjectID && clientData.Projects ) {
							vm.projectProject = clientData.Projects.find( project => project.ProjectID == vm.ProjectID ) || null;
						}
						//find default contact for project/account (currently merging all contacts into one string...)
						if(clientData.ClientContacts && clientData.ClientContacts.length > 0) {
							vm.DefaultContact = clientData.ClientContacts.filter( contact => contact.DefaultContact == '1' ).map(x => x.ContactName).join("/") || "";
						}
						else {
							vm.DefaultContact = "";
						}
						//get PO number and set field value
						if(!vm.JobPO){
							vm.JobPO = vm.projectProject && vm.projectProject.PO? vm.projectProject.PO : clientData.ClientPO;
						}
						vm.ClientAddresses = clientData.ClientAddresses;
						typeof onSuccess == 'function' && onSuccess();
	                },
					onError: function() { typeof onError == 'function' && onError() },
	            });
			},

			setProjectFromProjectId: function(projectId, onSuccess = null, onError = null) {
				this.ProjectID = projectId;
				if ( ! this.client ) {
					return;
				}
				const vm = this;
	            window.ajaxCall({
	                data : {
	                    action: 'get_client_data',
	                    client_id: vm.client.id
	                },
	                onSuccess : function( response ) {
						const clientData = response.data || null;

						if ( ! vm.clientData ) {
							vm.clientData = clientData;
						} else if ( clientData != null ) {
							vm.clientData.Projects = clientData.Projects;
						}
						vm.projectProject = clientData.Projects && clientData.Projects.find( project => project.ProjectID == projectId ) || null;

						tab.autofocus();

						onSuccess && onSuccess();
	                },
					onError: function() { typeof onError == 'function' && onError() },
	            });
			},



			// Add elsewhere

			addProjectName: function() {
				var d = new Date();
				var date = (d.getMonth()+1)+"-"+d.getDate()+"-"+d.getFullYear()+" "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();
				vmProjectName.newProject(
					projectId => {
						this.setProjectFromProjectId( projectId, () => setTimeout(projectNameTab.drawTable, 0) );
						projectNameTab.show();
					},
					null,
					date,
					this.client ? this.client.id : null,
				);
			},

			deleteProjectData: function(data, insert = false) {
				if ( this.getUpdateLockLevel() ) { return; }
				if ( ! this.JobID ) { return; }
                const _this = this;
                window.ConfirmationModalManager.show({
                    title 		: 'Confirm Project Deletion',
                    message		: 'Are you sure you want to permanently delete Project "'
                                    + _this.JobNumber
                                    + '"?',
                    buttonText	: 'Delete',
                    callback 	: function() {
                        window.ajaxCall({
                            data : {
                                action: 'delete_project_job',
                                id: _this.JobID,
                            },
                            successMessage: 'Successfully Deleted Project',
                            onSuccess: function() {
								_this.clearProjectData();
                                tab.drawTable();
                            },
                            onError: function() { onError && onError() },
                        });
                    },
                });
			},

			requestFile: function( event ) {
				let target = event.target;
				// ignore click on file input itself
				if ( target.type === 'file' ) { return; }
				while ( target ) {
					const fileInput = Array.prototype.find.call( target.getElementsByTagName('input'), input => input.type == 'file' );
					if ( fileInput ) {
						fileInput.click();
						return;
					}
					target = target.parentElement;
				}
			},
			upload: function( event ) {
				const input = event.target;
				if ( input.files.length == 0 ) { return }
				console.log( input.files );
				const formData = new FormData();
				for (let i = 0; i < input.files.length; i++) {
					formData.append( 'attachments[]', input.files[i] );
				}

				this.processAttachmentsForm(formData);
			},
			processAttachmentsForm: function(formData) {
				formData.append( 'JobNumber', this.JobNumber );
				formData.append( 'session_id', ajax_object.session_id );
				formData.append( 'action', 'attach_to_job' );
				const _this = this;
				console.log(formData, this);
				jQuery.ajax( ajax_object.ajax_url, {
					method: 'POST',
					data: formData,
					processData: false,
					contentType: false,
					success: function( response ) {
						_this._data.attachments = response.data.attachments;
					},
					error: function(error) {
						console.error( 'Error:', error );
					},
				} );
			},
			openAttachment: function(attachment) {
				attachmentTab.controller.OpenAttachment(this.JobNumber, attachment);
			},
			removeAttachment: function(attachment) {
				const _this = this;
				window.ConfirmationModalManager.show({
					title: 'Delete Attachment: ' + attachment,
					message: 'Are you sure you want to permanently delete "' + attachment + '" from project #' + this.JobNumber + '?',
					buttonText: 'Delete',
					callback: function() {
						const formData = new FormData();
						formData.append( 'remove[]', attachment );
						_this.processAttachmentsForm(formData);
					},
				});
			},

			doElementAction: function(target, elClass, event) {
				this.loadProject( target.dataset.jobNumber, tab.showAndAutofocus );
			},

		},
		computed: {
			// data from local storage
			clientList: 			x => store.state.clientList,
			// dropdown options
			deliveryModeOptions: 	x => store.state.deliveryModeOptions,
			jobStatusOptions: 		x => store.state.jobStatusOptions,
			sampledByOptions: 		x => store.state.sampledByOptions,
		},
		watch: {
			ClientID         : function( value ) { return this.updateProject({ ClientID : value }) },
			DefaultContact   : function( value ) { return this.updateProject({ DefaultContact : value }) },
			DeliveryMode     : function( value ) { return this.updateProject({ DeliveryMode : value }) },
			FieldTech        : function( value ) { return this.updateProject({ FieldTech : value }) },
			//JobID          : value => {},
			//JobNumber      : value => {},
			JobPO            : function( value ) { return this.updateProject({ JobPO : value }) },
			JobStatusID      : function( value ) { return this.updateProject({ JobStatusID : value }) },
			LabComment       : function( value ) { return this.updateProject({ LabComment : value }) },
			LoginDate        : function( value ) { return this.updateProject({ LoginDate : value }) },
			ReportComment    : function( value ) { return this.updateProject({ ReportComment : value }) },
			ReportMethod     : function( value ) { return this.updateProject({ ReportMethod : value }) },
			SampledBy        : function( value ) { return this.updateProject({ SampledBy : value }) },
			Shelves          : function( value ) { return this.updateProject({ Shelves : value }) },
			DateReported     : function( value ) { return this.updateProject({ DateReported : value }) },
			JobDescription   : function( value ) {
				this.updateProject({ JobDescription : value });
				if ( vmSampleLogin.jobData && parseInt( vmSampleLogin.jobData.JobID ) == parseInt( this.JobID ) ) {
					vmSampleLogin.jobData.JobDescription = this.JobDescription;
				}
			},
			ProjectID        : function( value ) {
				this.projectProject = value && this.clientData && this.clientData.Projects.find( project => project.ProjectID == value ) || null;
				this.updateProject({ ProjectID : value });
			},
			jobStatus        : function( value ) { return this.JobStatusID = ( value && value.id || 1 ); },
			client: function( newValue, oldValue ) {
				if ( ! this.client ) { return }
				const _this = this;
				if(!this.DefaultContact) {	
					window.ajaxCall({	
						data : {	
							action: 'get_default_contacts',	
							clientId: _this.client.id,	
						},	
						successMessage: 'Successfully Fetched Default Contacts',	
						onSuccess: function({data}) {	
							_this.DefaultContact = data;	
						},	
					});	
				}
				this.ajaxLoadClientData( () => {
					if ( ! this.JobID  ) {
						this.newProjectData();
					} else {
						this.updateProject({ clientID : this.client ? this.client.id : null });
					}
				});
			},
			projectProject: function( newValue, oldValue ) {
				if ( oldValue && newValue && newValue.ProjectID == oldValue.ProjectID ) { return }
				if(newValue && typeof newValue === 'object') {
					this.ProjectID = newValue.ProjectID;
					this.projectGoBetween = newValue;
					if(newValue.PO)
						this.JobPO = newValue.PO;
				} else if(!newValue){
					this.ProjectID = null;
				}
			},
			projectGoBetween: function( newValue, oldValue ) {
				if ( typeof newValue === "string" ) { 
					var project = this.clientData && this.clientData.Projects.find( project => project.ProjectName == newValue );
					if(project && (!this.projectProject || project.ProjectName != this.projectProject.ProjectName)){
						this.projectProject = project;
					}
					return 
				}
				if(newValue && typeof newValue === "object" && (!this.projectProject || newValue.ProjectID != this.projectProject.ProjectID)) {
					this.projectProject = newValue;
				} else if(!newValue) {
					this.ProjectID = null;
					this.projectProject = null;
				}
			}
		},
	}) );

	projectNameTab = AppTabs.getTab( 'project-name' );
	vmProjectName = projectNameTab.controller;
	sampleLoginTab = AppTabs.getTab( 'sample' );
	vmSampleLogin = sampleLoginTab.controller;
}

AppTabs.createTab( {
	name: 'project',
	icon: 'flask',
	text: 'Project',
	//preload: 'vmProject',
	actionElementClasses: [ 'project-link' ],
	create: createTab,
} );

})();
